module.exports = __webpack_public_path__ + "img/15.487eae0d.jpg";